import { CarrotJsonSchema, SchemaErrorMetadata, SchemaErrorMetadataName } from './types';

export function getHumanReadableErrorMessage(schema: CarrotJsonSchema) {
    const fieldName: string = schema?.shortTitle ?? schema?.title ?? '';
    return `${fieldName} ${schema.validationMessage}`;
}

export function mapSchemaToErrorMetadata(
    schema: CarrotJsonSchema,
    overrideTitle?: (originalTitle: string) => string
): SchemaErrorMetadata {
    const originalTitle: string = schema.shortTitle ?? schema.title ?? '';
    return {
        [SchemaErrorMetadataName.fieldName]: overrideTitle ? overrideTitle(originalTitle) : originalTitle,
        [SchemaErrorMetadataName.length]: schema.minLength == schema.maxLength ? schema.minLength : undefined,
        [SchemaErrorMetadataName.minLength]: schema.minLength,
        [SchemaErrorMetadataName.maxLength]: schema.maxLength,
    };
}
